"use client";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import Footer from "../components/Footer";

export default function ForgotPassword() {
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);

  // Allow Supabase to initialise the recovery session
  useEffect(() => {
    supabase.auth.getSession();
  }, []);

  const handleReset = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    if (password.length < 6) {
      setErrorMsg("Password must be at least 6 characters.");
      return;
    }

    if (password !== confirm) {
      setErrorMsg("Passwords do not match.");
      return;
    }

    setLoading(true);

    const { error } = await supabase.auth.updateUser({
      password,
    });

    if (error) {
      setErrorMsg(error.message);
      setLoading(false);
      return;
    }

    setSuccessMsg("Your password has been updated.");

    setTimeout(() => {
      navigate("/login");
    }, 1500);

    setLoading(false);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="nhsuk-width-container flex-grow">
        <main className="nhsuk-main-wrapper">
          <div className="login-container mx-auto p-4 max-w-md">
            <h1 className="nhsuk-heading-l text-center mb-6">
              Reset your password
            </h1>

            {errorMsg && (
              <div className="nhsuk-error-summary">
                <p className="nhsuk-error-message mb-0">{errorMsg}</p>
              </div>
            )}

            {successMsg && (
              <div className="nhsuk-inset-text">
                <p className="mb-0">{successMsg}</p>
              </div>
            )}

            <form onSubmit={handleReset} className="space-y-4">
              <div className="nhsuk-form-group">
                <label className="nhsuk-label">New password</label>
                <input
                  type="password"
                  className="nhsuk-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="nhsuk-form-group">
                <label className="nhsuk-label">Confirm password</label>
                <input
                  type="password"
                  className="nhsuk-input"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                />
              </div>

              <button className="nhsuk-button w-full" disabled={loading}>
                Update password
              </button>
            </form>
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
}
